import React, { createContext, useContext, useState, ReactNode } from "react";
import "../components/Notification";
import Notification from "../components/Notification";
type NotificationType = "validation" | "info" | "warning" | "error";

type NotificationData = {
  id: string;
  type: NotificationType;
  title: string;
  subtitle?: string;
  duration?: number;
};

type NotificationContextType = {
  notify: (n: Omit<NotificationData, "id">) => void;
};

const NotificationContext = createContext<NotificationContextType | undefined>(undefined);

export const useNotification = () => {
  const context = useContext(NotificationContext);
  if (!context) throw new Error("useNotification must be used within NotificationProvider");
  return context;
};

export const NotificationProvider = ({ children }: { children: ReactNode }) => {
  const [notifications, setNotifications] = useState<NotificationData[]>([]);

  const notify = (notification: Omit<NotificationData, "id">) => {
    const id = Math.random().toString(36).substr(2, 9);
    setNotifications((prev) => [...prev, { ...notification, id }]);
  };

  const removeNotification = (id: string) => {
    setNotifications((prev) => prev.filter((n) => n.id !== id));
  };

  return (
    <NotificationContext.Provider value={{ notify }}>
      {children}
      <div className="notification-container">
        {notifications.map((n) => (
          <Notification key={n.id} {...n} onClose={removeNotification} />
        ))}
      </div>
    </NotificationContext.Provider>
  );
};
